module.exports = __webpack_public_path__ + "img/Icon_Lugares_de_Servicio.238b65ab.svg";